export const basename = (v: string): string => {
  const index = v.lastIndexOf("/");
  if (index === -1) return v;
  return v.substring(index + 1);
};
